module.exports = __webpack_public_path__ + "static/media/Jedc.4e92534e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Jedc.svg
// module id = 424
// module chunks = 25